import React from "react";
import * as Scrivito from "scrivito";
import { TranslateWrapper } from "components/TranslateWrapper";
import { useTranslate } from "hooks";

export const ProductListSizeSwitcher = Scrivito.connect(() => {
  const translate = useTranslate();
  const projectProductCompactList = translate("PROJECT_PRODUCT_COMPACT_LIST");
  const projectProductExtendedList = translate("PROJECT_PRODUCT_EXTENDED_LIST");

  return (
    <div className="mx-2">
      <span id="compactList">{` ${translate(
        "PROJECT_PRODUCT_COMPACT_LIST",
      )}`}</span>
      <span id="extendedList" className="font-normal text-gray-400">
        {` - ${translate.stringOnly("PROJECT_PRODUCT_EXTENDED_LIST", null)}`}
      </span>
      {typeof projectProductCompactList === "object" && (
        <TranslateWrapper
          tooltipId="compactList"
          tooltipText={projectProductCompactList.props.tooltipText}
        />
      )}
      {typeof translate("PROJECT_PRODUCT_EXTENDED_LIST") === "object" && (
        <TranslateWrapper
          tooltipId="extendedList"
          tooltipText={projectProductExtendedList.props.tooltipText}
        />
      )}
    </div>
  );
});
